import React, { useState } from "react";
import EditorLayout from "../../components/editor/EditorLayout";
import GenerationSidebar from "../../components/editor/left-sidebar/generation-sidebar";
import ColorSettingsSidebar from "../../components/editor/right-sidebar/color-settings-sidebar";
import TextSettingsSidebar from "../../components/editor/right-sidebar/text-settings-sidebar";
import UploadSettingsSidebar from "../../components/editor/right-sidebar/upload-settings-sidebar";
import Dashboard from "../../components/editor/dashboard/dashboard";

const EditorPage = () => {
  const [activeOverlay, setActiveOverlay] = useState("color");

  const renderRightSidebar = () => {
    if (activeOverlay === "text") return <TextSettingsSidebar setActiveOverlay={setActiveOverlay} />;
    if (activeOverlay === "upload") return <UploadSettingsSidebar setActiveOverlay={setActiveOverlay} />;
    return <ColorSettingsSidebar setActiveOverlay={setActiveOverlay} />;
  };

  return (
    <EditorLayout
      leftSidebar={<GenerationSidebar />}
      rightSidebar={renderRightSidebar()}
      rightSidebarClass={activeOverlay === "upload" ? "upload_active_sidebar" : ""}
    >
      <Dashboard activeOverlay={activeOverlay} />
    </EditorLayout>
  );
};

export default EditorPage;
